import { HTTP } from '@/services/axios';

export async function getMods({filterText,orderCol,orderSort,page,records}){
    let result = {};
    
    await HTTP.get('/app/core/Mod/getModList.php',{
        params:{
            filterText,
            orderCol,
            orderSort,
            page,
            records
        }
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getMod({modId}){
    let result = {};
  
    await HTTP({
        method: 'get',
        url: `/app/core/Mod/getModData.php?modId=${modId}`,
    })
    .then(response => {
        console.log(response.data)
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });
    return result;
}


export async function unlockMod({modId}){
    let result = {};

    var data = {'myRecordID':modId};
    
    await HTTP({
        method: 'patch',
        url: '/app/core/Mod/controlModUnlock.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getAuthorizationsToMod({modId}){
    let result = {};

    await HTTP({
        method: 'get',
        url: `/app/core/Mod/getAuthorizationData.php?modId=${modId}`
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getModOptions(){
    let result = {};
    var bodyFormData = new FormData();
    
    await HTTP({
        method: 'get',
        url: '/app/core/Mod/getModOptions.php',
        data: bodyFormData
    })
    .then(response => {
        console.log(response.data)
        result = response.data.result;
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}


export async function createMod({data}){
    let result = {};

    await HTTP({
        method: 'post',
        url: '/app/core/Mod/controlModSave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function saveMod({data}){
    let result = {};

    await HTTP({
        method: 'put',
        url: '/app/core/Mod/controlModSave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function deleteMod({data}){
    let result = {};

    await HTTP({
        method: 'delete',
        url: '/app/core/Mod/controlModDelete.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}


export async function saveAuthorization({newAuthorization,modId}){
    let result = {};

    var data = {'modId':modId,'newAuthorization':newAuthorization};
    
    await HTTP({
        method: 'post',
        url: '/app/core/Mod/controlAuthorizationSave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function deleteAuthorization({authorizationId}){
    let result = {};
   
    var data = {'authorizationId':authorizationId};
    
    await HTTP({
        method: 'delete',
        url: '/app/core/Mod/controlAuthorizationDelete.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}